import { Link } from "react-router-dom";

export default function AboutSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-8 lg:px-12">
      <div className="max-w-3xl mx-auto text-center">
        <p className="text-xs md:text-sm font-medium text-accent-700 tracking-widest uppercase mb-4">
          Understanding the System
        </p>
        <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-900 mb-6 md:mb-8">
          What Is Mulebuy Spreadsheet?
        </h2>
        <div className="space-y-4 md:space-y-5 text-left">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
            <strong className="text-foreground-900">Mulebuy Spreadsheet</strong> is a structured product sourcing system that allows users to browse, compare, and select products from China-based suppliers through an organized spreadsheet format. It replaces the chaos of traditional browsing with a clean, filterable interface designed specifically for international buyers.
          </p>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
            The system consolidates <strong className="text-foreground-900">filtered product lists</strong>, <strong className="text-foreground-900">verified supplier data</strong>, <strong className="text-foreground-900">price comparisons</strong>, and <strong className="text-foreground-900">agent-based ordering systems</strong> into one accessible resource. This makes Mulebuy Spreadsheet one of the most efficient sourcing tools available in 2026, trusted by thousands of global shoppers who want to find the best products at the best prices.
          </p>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
            Whether you are hunting for the latest streetwear drops, building a wardrobe of essentials, or sourcing products for resale, the <strong className="text-foreground-900">Mulebuy Spreadsheet system</strong> gives you the organized data you need to make smarter purchasing decisions.
          </p>
        </div>
        <div className="mt-6">
          <Link
            to="/blog/what-is-mulebuy-spreadsheet-complete-beginner-guide"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
          >
            Read the Complete Beginner Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="mt-6 flex items-center justify-center">
          <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-accent-100">
            <i className="ri-file-list-3-line text-accent-600 text-xl md:text-2xl"></i>
          </div>
        </div>
      </div>
    </section>
  );
}